const set_storage = () => {
  localStorage.setItem('visite', true);
  // delete localStorage.visite;
}

export { set_storage }
